import {Trans} from '@lingui/macro';
import _ from 'lodash';
import React, {FC, useState} from 'react';

import {CardModel} from '../../../../../../../../../../src/models/api/cardModel';
import {AsyncHandlerOf, Handler} from '../../../../../../../../../shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../../../../../shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../../../../shared/ui/src/components/buttons/buttonConstants';
import {useContactsManagerContext} from '../../../../contactsManagerContext';
import {DeleteMultipleCardsConfirmationDialog} from '../../../../dialogs/deleteMultipleCardsConfirmationDialog';
import {buildContactsManagerDeleteContactEvent} from '../../../../helpers/trackingHelpers';

/*
 * Props.
 */

interface ContactsTableMultiDeleteActionProps {
  cards: ReadonlyArray<CardModel>;
  deleteCardsAsync: AsyncHandlerOf<ReadonlyArray<number>>;
  onDeleteSuccess: Handler;
}

/*
 * Component.
 */

export const ContactsTableMultiDeleteAction: FC<ContactsTableMultiDeleteActionProps> = (props) => {
  const {cards, deleteCardsAsync, onDeleteSuccess} = props;
  const [isShowingDeleteDialog, setIsShowingDeleteDialog] = useState(false);
  const {onTrackHandler} = useContactsManagerContext();

  const onDeleteHandler = async () => {
    setIsShowingDeleteDialog(false);
    try {
      await deleteCardsAsync(cards.map((card) => card.id));
      onDeleteSuccess();
      const namespaces = _(cards)
        .map((card) => card.namespace)
        .uniq()
        .value();
      onTrackHandler(buildContactsManagerDeleteContactEvent(cards.length, namespaces));
    } catch {
      // TODO: Show a failed banner.
    }
  };

  return (
    <>
      <Button
        variant={ButtonVariantsEnum.SECONDARY_DANGER}
        hasHover={isShowingDeleteDialog}
        onClick={() => setIsShowingDeleteDialog(true)}
      >
        <Trans id="contact-manager-table-multi-select-actions-delete">Delete</Trans>
      </Button>
      {isShowingDeleteDialog && (
        <DeleteMultipleCardsConfirmationDialog
          cards={cards}
          onClose={() => setIsShowingDeleteDialog(false)}
          onDelete={onDeleteHandler}
        />
      )}
    </>
  );
};
